import PasswordReset from "@/pages/PasswordResetRequest";
import { createFileRoute } from "@tanstack/react-router";
import React from "react";

const PasswordResetRequest = () => <PasswordReset />;

export const Route = createFileRoute("/external/password_reset_request")({
  component: PasswordResetRequest,
});
